module.exports = __webpack_public_path__ + "img/alarm.e6d0e7d8.svg";